<template>
  <div class="columns is-multiline issues-view"  v-if="hasIssues">
    <div class="column is-12">
      <title-component>
        <translate>Issue to solve</translate>
      </title-component>
      <subtitle-component :size="5">
        <translate>Here we list any information that you will need to complement and send to Kiwa</translate>
      </subtitle-component>
    </div>
    <div class="column is-12">
      <div class="flex-table">
        <div class="flex-table-row flex-table-header">
          <div class="flex-table-row-item" v-translate>Service</div>
          <div class="flex-table-row-item" v-translate>Title</div>
          <div class="flex-table-row-item" v-translate>Description</div>
        </div>
        <issue-view v-for="issue in issues" :key="issue.id" :issue="issue" :disabled="customer.needsInvoiceInformationUpdate" @issueResolved="retrieveIssues">
        </issue-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import IssueView from '@/views/customer/issues/IssueView'
  import TitleComponent from '@/components/layout/TitleComponent.vue'
  import { errorHandler } from '@/mixins/mixins'
  import SubtitleComponent from '@/components/layout/SubTitleComponent'

  export default {
    name: 'issues-view',
    mixins: [errorHandler],
    components: {
      SubtitleComponent,
      TitleComponent,
      IssueView
    },
    props: {
      customer: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState({
        issues: state => state.issueModule.issues
      }),
      hasIssues () {
        return this.issues.length > 0
      }
    },
    methods: {
      ...mapActions([
        'getIssues',
        'setCase'
      ]),
      setCaseOnIssue (issue) {
        this.setCase(issue.caseId).then((reponse) => {
          issue.caseNumber = reponse.caseNumber
          issue.serviceCode = reponse.service.code
        })
      },
      retrieveIssues () {
        this.getIssues().then(() => {
          for (let issue of this.issues) {
            this.setCaseOnIssue(issue)
          }
        }).catch((err) => {
          this.handleError(err)
        })
      }
    },
    mounted () {
      this.retrieveIssues()
    }
  }
</script>
